import { defineMessages } from 'react-intl'

export const commonMessages = defineMessages({
  cancel: {
    id: 'labels.cancel',
    description: 'Cancel button label',
    defaultMessage: 'Cancel',
  },
  back: {
    id: 'labels.back',
    description: 'Back button label',
    defaultMessage: 'Back',
  },
  apply: {
    id: 'labels.apply',
    description: 'Apply button label',
    defaultMessage: 'Apply',
  },
  submit: {
    id: 'labels.submit',
    description: 'Submit button label',
    defaultMessage: 'Submit',
  },
  refresh: {
    id: 'labels.refresh',
    description: 'Refresh button label',
    defaultMessage: 'Refresh',
  },
  ok: {
    id: 'labels.ok',
    description: 'OK button label',
    defaultMessage: 'OK',
  },
  close: {
    id: 'labels.close',
    description: 'Close button label',
    defaultMessage: 'Close',
  },
  save: {
    id: 'labels.save',
    description: 'Save button label',
    defaultMessage: 'Save',
  },
  next: {
    id: 'labels.next',
    description: 'Next button label',
    defaultMessage: 'Next',
  },
  delete: {
    id: 'labels.delete',
    description: 'Delete button label',
    defaultMessage: 'Delete',
  },
  copy: {
    id: 'labels.copy',
    description: 'Copy button label',
    defaultMessage: 'Copy',
  },
  copied: {
    id: 'labels.copied',
    description: 'Copied input text',
    defaultMessage: 'Copied!',
  },
  done: {
    id: 'labels.done',
    description: 'Usually successful button text',
    defaultMessage: 'Done',
  },
  success: {
    id: 'labels.success',
    description: 'success label',
    defaultMessage: 'Success',
  },
  error: {
    id: 'labels.error',
    description: 'error label',
    defaultMessage: 'Error',
  },
  skip: {
    id: 'labels.skip',
    description: 'Skip button label',
    defaultMessage: 'Skip',
  },
  items: {
    id: 'labels.items',
    description:
      '"items" word following after number. For places like number of search results (and number does not need localize).',
    defaultMessage: 'items',
  },
  commonError: {
    id: 'labels.commonError',
    description: 'Something went wrong error message',
    defaultMessage: 'Something went wrong',
  },
  deployError: {
    id: 'labels.deployError',
    description: 'Redeploy missing sub error message',
    defaultMessage: 'An active Savant Essentials subscription is required to deploy configuration to this home.',
  },
  sort: {
    id: 'labels.sort',
    description:
      'Label usually used in some helpful popups showing that use is/may sort something (e.g. table column)',
    defaultMessage: 'Sort',
  },
  noResultsFound: {
    id: 'labels.noResultsFound',
    description: 'No results found message',
    defaultMessage: 'No results found',
  },
  noMobileSupport: {
    id: 'labels.noMobileSupport',
    description: 'No mobile support message',
    defaultMessage: 'No mobile support',
  },
  renameDomainError: {
    id: 'labels.renameDomainError',
    description: 'Error message for failed validation of Job/Domain/Group name',
    defaultMessage:
      'Name may contain letters, numbers, apostrophes, periods, underscores, and hyphens, and not more than 64 symbols.',
  },
  download: {
    id: 'labels.download',
    description: 'Download label',
    defaultMessage: 'Download',
  },
  noName: {
    id: 'labels.noName',
    description: 'No name text',
    defaultMessage: 'No name',
  },
  essentialPlan: {
    id: 'labels.essentialPlan',
    description: 'Text for Essentials home subscription plan',
    defaultMessage: 'Savant Essentials',
  },
  networkPlan: {
    id: 'labels.networkPlan',
    description: 'Text for Smart Network subscription plan',
    defaultMessage: 'Smart Network',
  },
  fixCriteria: {
    id: 'labels.fixCriteria',
    description:
      'Helper text for user to change search conditions to get better results',
    defaultMessage: 'Try to adjust search criteria',
  },
  showMore: {
    id: 'labels.showMore',
    description: 'Common text for "Show More" action',
    defaultMessage: 'Show More',
  },
  promptUnsavedForm: {
    id: 'labels.promptUnsavedForm',
    description:
      'Message in a dialog when user tries to leave the page that has unsaved form changes',
    defaultMessage: 'You have unsaved changes. Are you sure?',
  },
  promptConfirm: {
    id: 'labels.promptConfirm',
    description: 'Message in a dialog for confirmation',
    defaultMessage: 'Are you sure you want to ',
  },
})
